(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ring-size-guide"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ring-size-guide]').forEach((guide) => {
  const form = guide.querySelector('.zius-size-converter__form');
  const input = guide.querySelector('[data-measurement]');
  const type = guide.querySelector('[data-measurement-type]');
  const result = guide.querySelector('[data-size-result]');
  const values = JSON.parse(guide.nextElementSibling.textContent);
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const measurement = Number(input.value);
    if (!Number.isFinite(measurement) || measurement <= 0) {
      input.focus();
      return;
    }
    const key = type.value === 'diameter' ? 'd' : 'c';
    const closest = values.reduce((best, item) => Math.abs(item[key] - measurement) < Math.abs(best[key] - measurement) ? item : best);
    guide.querySelector('[data-us-size]').textContent = 'US ' + closest.us;
    guide.querySelector('[data-size-detail]').textContent = 'Inside diameter ' + closest.d + ' mm · Circumference ' + closest.c + ' mm · UK ' + closest.uk + ' · EU ' + closest.eu;
    result.hidden = false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zius-collections"] && !Shopify.designMode) return;
  try {
    
const initializeShapeSelectors=()=>{document.querySelectorAll('[data-nlx-shapes]').forEach((section)=>{if(section.dataset.initialized==='true')return;section.dataset.initialized='true';const rail=section.querySelector('.nlx__rail');const items=[...section.querySelectorAll('.nlx__item')];const title=section.querySelector('.nlx__active-title');const description=section.querySelector('.nlx__active-description');const activeLink=section.querySelector('.nlx__active-link');const progress=section.querySelector('.nlx__progress-fill');let activeIndex=0;let timer;const activate=(index,behavior='smooth')=>{activeIndex=(index+items.length)%items.length;items.forEach((item,itemIndex)=>{const active=itemIndex===activeIndex;item.classList.toggle('is-active',active);const link=item.querySelector('.nlx__card');if(active)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current')});const activeItem=items[activeIndex];title.textContent=activeItem.dataset.title;description.textContent=activeItem.dataset.description;activeLink.href=activeItem.dataset.url;progress.style.width=`${((activeIndex+1)/items.length)*100}%`;const target=activeItem.offsetLeft-(rail.clientWidth-activeItem.offsetWidth)/2;rail.scrollTo({left:target,behavior})};const stop=()=>window.clearInterval(timer);const start=()=>{stop();if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches)timer=window.setInterval(()=>activate(activeIndex+1),3500)};items.forEach((item,index)=>{item.querySelector('.nlx__card').addEventListener('mouseenter',()=>{stop();activate(index)});item.querySelector('.nlx__card').addEventListener('focus',()=>{stop();activate(index)})});section.querySelector('.nlx__nav--prev').addEventListener('click',()=>{activate(activeIndex-1);start()});section.querySelector('.nlx__nav--next').addEventListener('click',()=>{activate(activeIndex+1);start()});section.addEventListener('mouseleave',start);activate(0,'auto');start()})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeShapeSelectors);else initializeShapeSelectors();document.addEventListener('shopify:section:load',initializeShapeSelectors);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zius-custom-order"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-zco-file]').forEach((input)=>{if(input.dataset.connected)return;const preview=input.closest('.zco__field').querySelector('[data-zco-preview]');const image=preview.querySelector('img');input.addEventListener('change',()=>{const file=input.files[0];if(!file){preview.hidden=true;return}image.src=URL.createObjectURL(file);preview.hidden=false});preview.querySelector('[data-zco-remove]').addEventListener('click',()=>{input.value='';image.removeAttribute('src');preview.hidden=true});input.dataset.connected='true'});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zius-dual-bestsellers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const tab = event.target.closest('.zj-dual-best__tabs [role="tab"]');
    if (!tab) return;
    const tabs = Array.from(tab.parentElement.querySelectorAll('[role="tab"]'));
    const section = tab.closest('.zj-dual-best');
    tabs.forEach(function (item) {
      const selected = item === tab;
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      item.tabIndex = selected ? 0 : -1;
      const panel = section.querySelector('#' + item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
